import posthog from 'posthog-js';

/**
 * Safe PostHog wrappers — never call posthog.* directly outside of main.tsx.
 * These guards prevent crashes when PostHog is disabled (POSTHOG_KEY not set)
 * or when the SDK has not yet initialised.
 */

export function safeCapture(
  event: string,
  props?: Record<string, unknown>,
): void {
  try {
    if (posthog.__loaded) {
      posthog.capture(event, props);
    }
  } catch {
    // Never break the user flow
  }
}

export function safeIdentify(
  distinctId: string,
  personProperties?: Record<string, unknown>,
): void {
  try {
    if (posthog.__loaded) {
      posthog.identify(distinctId, personProperties);
    }
  } catch {
    // Never break the user flow
  }
}

export function safeRegister(superProperties: Record<string, unknown>): void {
  try {
    if (posthog.__loaded) {
      posthog.register(superProperties);
    }
  } catch {
    // Never break the user flow
  }
}

export function safeGroup(
  groupType: string,
  groupKey: string,
  groupProperties?: Record<string, unknown>,
): void {
  try {
    if (posthog.__loaded) {
      posthog.group(groupType, groupKey, groupProperties);
    }
  } catch {
    // Never break the user flow
  }
}

export function safeReset(): void {
  try {
    if (posthog.__loaded) {
      posthog.reset();
    }
  } catch {
    // Never break the user flow
  }
}
